import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import styles from 'src/components/AutopromoBtnImg.scss';


const getImages = imgs => imgs.map(({ url, density }) => `${url} ${density}x`).join(', ');

const AutopromoButtonImage = ({
  url, linkTitle, img, altText, containerAlign
}) => {
  const renderButtonImage = () => (
    <picture>
      <source
        key={ altText }
        srcSet={ getImages(img) }
      />
      <img
        alt={ altText }
        className={ classNames(styles['autopromo-btn-img']) }
        src={ img[0].url }
      />
    </picture>
  );

  return (
    <div className={ classNames(styles['img-button-wrapper'],
      {
        [styles['img-button-wrapper--centered']]: containerAlign === 'center'
      }) }
    >
      <a key={ url } href={ url } title={ linkTitle }>
        { renderButtonImage() }
      </a>
    </div>
  );
};

AutopromoButtonImage.propTypes = {
  altText: PropTypes.string.isRequired,
  containerAlign: PropTypes.string.isRequired,
  img: PropTypes.arrayOf(Object).isRequired,
  linkTitle: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default AutopromoButtonImage;
